import React from 'react';
import PropTypes from 'prop-types';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';
import LoadingSpinner from 'dpl/components/LoadingSpinner';
import StripeChargeModalPaymentSummaryV3 from 'dpl/components/StripeCharge/New/StripeChargeModal/StripeChargeModalPaymentSummaryV3';

export default function SummaryV2({
  paymentRequest,
  isLoadingSummary,
  handleChangeTierSelection,
  lineItems,
  taxAmount,
  taxBreakdown
}) {
  const { formState } = useFormContext();

  if (isLoadingSummary) {
    return (
      <div className="flex flex-column items-center justify-center tc absolute top-0 right-0 bottom-0 left-0">
        <LoadingSpinner className="loading-spinner--medium" />
        <span className="nt3">Updating...</span>
      </div>
    );
  }

  return (
    <div className="relative" style={{ minHeight: 160 }}>
      <div>
        <h2 className="font-serif font-20">Summary</h2>
        <StripeChargeModalPaymentSummaryV3
          className="ba br12 b--default"
          amountTotal={paymentRequest.total_in_dollars}
          amountSubtotal={formState.amount_in_dollars}
          taxAmount={taxAmount}
          taxBreakdown={taxBreakdown}
          lineItems={lineItems}
          paymentTier={formState.payment_tier}
          paymentMethod={formState.payment_method}
          category={formState.category}
          onChangeSelection={handleChangeTierSelection}
          feeBundle={paymentRequest.fee_bundle}
        />
      </div>
    </div>
  );
}

SummaryV2.propTypes = {
  paymentRequest: PropTypes.shape({
    total_in_dollars: PropTypes.string,
    amount_in_dollars: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    category: PropTypes.string,
    fee_bundle: PropTypes.shape({
      amount: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      long_description: PropTypes.string.isRequired,
      tooltip_description: PropTypes.string.isRequired,
      item_types: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  }).isRequired,
  isLoadingSummary: PropTypes.bool,
  handleChangeTierSelection: PropTypes.func.isRequired,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      amount_in_dollars: PropTypes.string,
      description: PropTypes.string,
      item_type: PropTypes.string
    })
  ).isRequired,
  taxAmount: PropTypes.string.isRequired,
  taxBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string
    })
  )
};

SummaryV2.defaultProps = {
  taxBreakdown: null,
  isLoadingSummary: false
};
